// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".edbf0c0a9dbe650703bb80ce8c0627dc.js";
};